// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3w51J","notes":"Notes_notes__HN9VE","note":"Notes_note__cbXp0","markdown":"Notes_markdown__2OP7w"};